'use client'

import { BaseAxisProps } from 'recharts/types/util/types'

import { TooltipProps } from '../../../types/Dashboard/types'
import { formatNumber, NumberType } from '../../../utils/formatNumbers'

export const LandingPageChartTooltip = ({
  dateFormatter,
  entryPayloadFilter,
  payload,
}: {
  entryPayloadFilter: TooltipProps['entryPayloadFilter']
  payload: TooltipProps['payload']
  dateFormatter: BaseAxisProps['tickFormatter']
}) => {
  if (!payload?.length) return null

  const filteredPayload = payload
    .map(entry => (entryPayloadFilter ? entryPayloadFilter(entry) : { ...entry }))
    .filter(entry => entry !== null)

  const susde = filteredPayload.find(entry => entry.name === 'sUSDe')

  const treasuries = filteredPayload.find(entry => entry.name === 'Treasuries')

  const usdt = filteredPayload.find(entry => entry.name === 'USDT/USDC')

  return (
    <article className="rounded-[10px] bg-gradient-to-r from-[#91B3F0]/40 to-[#1f2124] p-[1px] w-[220px]">
      <div className="h-full w-full rounded-[10px] bg-background-accent/40">
        <div className="py-3.5 px-4 linechart-tooltip-gradient rounded-[10px]">
          <p className="text-xs uppercase text-[#BDD1F6] mb-[10px]">
            {dateFormatter?.(filteredPayload[0].payload.date, 0)}
          </p>

          <div className="flex flex-col gap-1 mb-[10px]">
            <div className="flex items-center gap-1">
              <div className="h-[3px] w-[12px] bg-text-accent" />
              <p className="text-sm text-text-accent">{susde?.name}</p>
            </div>
            <p className="text-lg font-bold">{formatNumber(susde?.value, NumberType.FiatTokenAmt)}</p>
          </div>

          <div className="flex flex-col gap-1 mb-[10px]">
            <div className="flex items-center gap-1">
              <div className="h-[3px] w-[12px] bg-[#C2C2C0]" />
              <p className="text-sm text-white">{treasuries?.name}</p>
            </div>
            <p className="text-lg font-medium">{formatNumber(treasuries?.value, NumberType.FiatTokenAmt)}</p>
          </div>

          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-1">
              <div className="w-[10px] flex items-center">
                <div className={`h-[2px] w-[2px] mr-[2px] bg-[#6f6f6f]`} />
                <div className={`h-[2px] w-[2px] mr-[2px] bg-[#6f6f6f]`} />
                <div className={`h-[2px] w-[2px] bg-[#6f6f6f]`} />
              </div>
              <p className="text-sm text-white">{usdt?.name}</p>
            </div>
            <p className="text-lg font-medium">{formatNumber(usdt?.value, NumberType.FiatTokenAmt)}</p>
          </div>
        </div>
      </div>
    </article>
  )
}
